export enum KeyboardEventCodeType {
  Enter = 'Enter',
  Escape = 'Escape',
  F3 = 'F3',
  F = 'KeyF',
}
